/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Possible shift types
 */
export enum ShiftType {
    PICKUP = 'pickup',
    DROPOFF = 'dropoff',
    MIXED = 'mixed',
}
